<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Integrations'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <form [formGroup]="form" novalidate action="#">
        <tidy-row class="extra-bottom-padding">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/svg/search-outline.svg'" />
        </tidy-row>
      </form>
      @for (option of integrationOptions; track option) {
        <tidy-card>
          <tidy-card-button (action)="goToAddIntegration(option)" class="no-below-stroke">
            <tidy-image
              [src]="option.logo_url"
              style="width:70%; height:30px" />
            @if (option.short_description !== null) {
              <tidy-row>
                <tidy-text
                  [body]="option.short_description" />
              </tidy-row>
            }
          </tidy-card-button>
        </tidy-card>
      }
    }

    @if (!loaded) {
      <tidy-card style="padding: 3px">
        <ion-skeleton-text animated="true" style="margin-left: 10px; width: 100px; height: 16px" />
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
      <tidy-card>
        <tidy-card-button [hideArrow]="true" class="no-below-stroke">
          <ion-skeleton-text animated="true" style="width: 100px; height: 50px" />
        </tidy-card-button>
        <tidy-row>
          <ion-skeleton-text animated="true" style="width: 100%" />
          <ion-skeleton-text animated="true" style="width: 100%" />
        </tidy-row>
      </tidy-card>
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
